import { KeycloakService } from 'keycloak-angular';
import { KeycloakLoginOptions } from 'keycloak-js';
import { BehaviorSubject } from 'rxjs';

import { inject, Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private readonly _keycloakService = inject(KeycloakService);

  keycloakLoginOptions: KeycloakLoginOptions = {
    redirectUri: environment.keycloak.redirectUri,
  }

  redirectToLoginPage(): Promise<void> {
    return this._keycloakService.login(this.keycloakLoginOptions);
  }

  isLoggedIn(): boolean {
    return this._keycloakService.isLoggedIn();
  }

  async getToken(): Promise<string> {
    try {
      return await this._keycloakService.getToken();
    } catch (error) {
      console.error('Error getting token', error);
      throw error;
    }
  }

  async refreshTokenIfNeeded(): Promise<void> {
    try {
      const isTokenExpired = this.isTokenExpired();
      if (isTokenExpired) {
        await this._keycloakService.updateToken(30);
      }
    } catch (error) {
      throw error;
    }
  }

  logout(): void {
    this._keycloakService.logout(environment.keycloak.postLogoutRedirectUri);
  }

  isTokenExpired(): boolean {
    return this._keycloakService.isTokenExpired();
  }
}
